function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 0h9a1 1 0 011 1v1a1 1 0 01-1 1H5a1 1 0 01-1-1V1a1 1 0 011-1zm3.207 5H14a1 1 0 011 1v1a1 1 0 01-1 1H8.207a.5.5 0 01-.353-.854L8.5 6.5l-.646-.646A.5.5 0 018.207 5zM5 10h9a1 1 0 011 1v1a1 1 0 01-1 1H5a1 1 0 01-1-1v-1a1 1 0 011-1zM.5 5.5h2A.5.5 0 003 5v-.5a.46.46 0 01.76-.35l2.297 1.97a.5.5 0 010 .76L3.76 8.85A.46.46 0 013 8.5V8a.5.5 0 00-.5-.5h-2A.5.5 0 010 7V6a.5.5 0 01.5-.5z",
  fill: "#9BADBC",
  fillRule: "evenodd"
});

var SvgDestinations = function SvgDestinations(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13"
  }, props), _ref);
};

export default SvgDestinations;